import { I18nConfig, TranslationChunksConfig, TranslationResources } from '@spartacus/core';

const core = {
  common: {
    home: 'Главная',
    promo: 'Акции и спецпредложения',
    useChat: 'Написать в чат',
  },
  roubles: '{{count}} руб.',
  searchBox: {
    placeholder: 'Поиск',
  },
  formErrors: {
    globalMessage: 'Форма, которую вы пытаетесь отправить, содержит ошибки.',
    required: 'Это поле нужно обязательно заполнить',
    requiredTrue: 'Это обязательное поле',
    cxInvalidEmail: 'Неверный формат электронной почты',
    cxInvalidPassword: 'Неверный формат пароля',
    cxPasswordsMustMatch: 'Пароли должны совпадать',
    cxEmailsMustMatch: 'Адреса электронной почты должны совпадать',
    cxStarRatingEmpty: 'Рэйтинг обязательно нужно заполнить',
    cxNoSelectedItemToCancel: 'Выберите хотя бы один элемент для отмены',
    cxContainsNonDigitCharacters: 'Введите только цифры',
    cxNotContainsDigitCharacters: 'Должен содержать цифры',
    cxNotContainsCharacters: 'Должен содержать буквы',
    minlength: 'Заполните поле до конца',
    maxlength: 'Превышено максимальное количество символов',
    mask: 'Заполните поле в соответствии с форматом',
    email: 'Заполните поле в соответствии с форматом xxx@xxx.xxx',
    min: 'Число должно быть не меньше {{min}}',
    max: 'Число должно быть не больше {{max}}',
  },
  httpHandlers: {
    badCode: 'Неправильный код',
    badGateway: 'Произошла ошибка сервера. Пожалуйста, попробуйте позже',
    badRequestPleaseLoginAgain: '{{ errorMessage }}. Пожалуйста, войдите снова',
    badRequestOldPasswordIncorrect: 'Старый пароль неверен',
    conflict: 'Уже существует',
    forbidden: 'У вас нет прав для выполнения этого действия',
    gatewayTimeout: 'Сервер не отвечает, повторите попытку позже',
    internalServerError: 'Произошла внутренняя ошибка сервера. Пожалуйста, повторите попытку позже',
    sessionExpired: 'Время сессии истекло. Пожалуйста, войдите снова',
    unknownError: 'Произошла неизвестная ошибка',
    unauthorized: {
      common: 'Произошла неизвестная ошибка авторизации',
      invalid_client: 'Неверные учетные данные клиента',
    },
    validationErrors: {
      missing: {
        card_cardType: 'Выбранная кредитная карта не поддерживается. Пожалуйста, выберите другую',
        card_accountNumber: 'Введенный номер кредитной карты недействителен',
        card_cvNumber: 'Введенный защитный код недействителен',
        card_expirationMonth: 'Введенная дата истечения срока действия кредитной карты недействительна',
        card_expirationYear: 'Введенная дата истечения срока действия кредитной карты недействительна',
        billTo_firstName: 'Введенное имя недействительно',
        billTo_lastName: 'Введенная фамилия недействительна',
        billTo_street1: 'Введенный адрес недействителен',
        billTo_street2: 'Введенный адрес недействителен',
        billTo_city: 'Введенный город недействителен для этой кредитной карты',
        billTo_state: 'Введенный штат / провинция недействителен для этой кредитной карты',
        billTo_country: 'Введенная страна недействительна для этой кредитной карты',
        billTo_postalCode: 'Почтовый индекс недействителен для этой кредитной карты',
        country: {
          isocode: 'Отсутствует страна',
        },
      },
      invalid: {
        card_expirationMonth: 'Введенная дата истечения срока действия кредитной карты недействительна',
        firstName: 'Введенное имя недействительно',
        lastName: 'Введенная фамилия недействительна',
        password: 'Введенный пароль недействителен',
        uid: 'UID недействителен',
        code: 'Код недействителен',
        email: 'Email не является допустимым',
      },
    },
    cartNotFound: 'Корзина не найдена',
    invalidCodeProvided: 'Предоставлен неверный код',
    couponNotFound: 'По данному коду ничего не найдено',
    couponNotFoundForSite: 'Промокод не активен в данном городе',
    couponNotActiveExpired: 'Промокод не активен',
    couponAlreadyRedeemed: 'Промокод уже использован',
    couponError: 'Ошибка применения промокода',
  },
  cartItems: {
    id: 'Код товара',
  },
  pageMetaResolver: {
    product: {
      description: '{{description}}',
      heading: '{{heading}}',
      title: '{{title}}',
    },
  },
  spinner: {
    loading: 'Загрузка..',
  },
};

const ru = {
  core,
};

const coreTranslations: TranslationResources = {
  ru,
};

const coreTranslationChunksConfig: TranslationChunksConfig = {
  core: ['common', 'roubles', 'searchBox', 'formErrors', 'httpHandlers', 'cartItems', 'pageMetaResolver', 'spinner'],
};

export const coreI18nConfig: I18nConfig = {
  i18n: {
    resources: coreTranslations,
    chunks: coreTranslationChunksConfig,
  },
};
